import SingleLevelItem from './SingleLevelItem';
import MultiLevelItem from './MultiLevelItem';

const MenuItem = ({ item, disabled, ...props }) => {
    return item.children?.length && !disabled ? (
        <MultiLevelItem item={item} {...props} />
    ) : (
        <SingleLevelItem item={item} disabled={disabled} {...props} />
    );
};

export default MenuItem;
